import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";

const styles = makeStyles<Theme>((theme) => ({
  paper: {
    fontFamily: `'Manrope', sans-serif`,
    top: "50%",
    left: "50%",
    transform: `translate(-50%, -50%)`,
    position: "absolute",
    justifyContent: "center",
    alignItems: "center",
    width: "55vw",
    borderRadius: 8,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    // padding: "1.5rem",
    [theme.breakpoints.down("md")]: {
      width: "65vw",
    },
    [theme.breakpoints.down("sm")]: {
      width: "85vw",
    },
  },
  modalBody: {
    height: "100%",
    width: "100%",
    position: "relative",
    "@media (min-height: 750px)": {
      overflowX: "hidden",
    },
    [theme.breakpoints.down("md")]: {
      overflowY: "scroll",
      overflowX: "hidden",
    },
    [theme.breakpoints.down("sm")]: {
      height: "70vh",
      overflowY: "scroll",
      overflowX: "hidden",
      paddingRight: ".55rem",
    },
    "& button": {
      fontFamily: `'Manrope', sans-serif`,
    },
  },
  modalHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "20px",
    padding: "1.5rem",
    paddingBottom: 0,
  },
  modalHeaderTitle: {
    marginBottom: 8,
    fontSize: 20,
    lineHeight: "28px",
    color: "#344054",
    fontWeight: "bold",
  },
  modalHeaderSubtitle: {
    fontSize: 14,
    lineHeight: "24px",
    color: "#6F727A",
    fontWeight: "normal",
  },
  modalSection: {
    padding: "0 1rem",
  },
  modalFooter: {
    position: "absolute",
    left: 0,
    bottom: 0,
    width: "100%",
    background: "#F7F7F9",
    height: 80,
    borderRadius: "0 0 8px 8px",
    padding: "16px 1.5rem",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    "& div": {
      gap: "10px",
    },
  },
  modalBodyTitle: {
    color: "#465869",
    fontSize: 18,
    lineHeight: "18px",
    fontWeight: "bold",
    marginBottom: "15px",
  },
  modalSectionHeader: {
    "& .steps": {
      display: "flex",
      gap: "16px",
      listStyle: "none",
      padding: 0,
      margin: 0,
      "& .step": {
        fontSize: 16,
        fontWeight: 700,
        color: "#93A9BD",
        lineHeight: "24px",
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        "& > span": {
          fontSize: 12,
          fontWeight: 700,
          lineHeight: "18px",
          marginRight: 15,
          color: "#fff",
          borderRadius: "50%",
          padding: "4px 10px",
          background: "#93A9BD",
        },
        "&.active": {
          color: "#465869",
          "& > span": {
            backgroundColor: "#38cfc4 !important",
          },
        },
        "&.error": {
          color: "#D92D20",
          "& > span": {
            backgroundColor: "#d5483eb8 !important",
          },
        },
      },
    },
  },
  modalSectionBody: {
    marginTop: 10,
    border: "1px solid #E4E7EC",
    padding: "1rem",
    borderRadius: "0 0 8px 8px",
    "& > div": {
      paddingBottom: 20,
    },
  },
  addressSectionTitle: {
    fontSize: 16,
    fontWeight: 700,
    lineHeight: "24px",
    color: "#465869",
  },
  paperBody: {
    marginTop: 12,
    width: "100%",
  },
  modalTabBody: {
    maxHeight: "35vh",
    overflow: "hidden auto",
    borderRadius: "0 0 8px 8px",
  },
}));

export default styles;
